// extracted by mini-css-extract-plugin
export default {"errorPage":"NotFound_errorPage__Q1wrg","error_container":"NotFound_error_container__7MQxy","zoom_area":"NotFound_zoom_area__HXMzs","link_container":"NotFound_link_container__et4ma"};